export const PAPER_SCAN_PAGE_HEIGHT_CM = 29.7;
export const PAPER_SCAN_QUESTION_ORIGIN_TOP_CM = 4.53;
export const PAPER_SCAN_BOTTOM_GUIDE_TOP_CM = 28.7;
export const PAPER_SCAN_CROP_MARGIN_CM = .1;
export const PAPER_SCAN_SAFETY_EPSILON_CM = .001;
export const PAPER_SCAN_HORIZONTAL_INSET_CM = .6;
export const PAPER_SCAN_QUESTION_PADDING_CM = .2;

export const PAPER_SCAN_SAFE_QUESTION_BOTTOM_CM = (
    PAPER_SCAN_BOTTOM_GUIDE_TOP_CM -
    PAPER_SCAN_CROP_MARGIN_CM -
    PAPER_SCAN_SAFETY_EPSILON_CM
);

export const PAPER_SCAN_TEMPLATE_SETTINGS = {
    marginTop: PAPER_SCAN_QUESTION_ORIGIN_TOP_CM,
    marginBottom: PAPER_SCAN_PAGE_HEIGHT_CM - PAPER_SCAN_SAFE_QUESTION_BOTTOM_CM,
    marginLeft: PAPER_SCAN_HORIZONTAL_INSET_CM,
    marginRight: PAPER_SCAN_HORIZONTAL_INSET_CM,
    padding: PAPER_SCAN_QUESTION_PADDING_CM,
};

export function isPaperScanTemplate(type, template) {
    return Number(type) === 2 && (Number(template) === 0 || Number(template) === 1);
}

export function shouldRenderMaterialHeading(type, template) {
    return !(Number(type) === 2 &&
        template !== null &&
        template !== undefined &&
        Number(template) === 0);
}

export function hasPaperScanGeometry(item) {
    return item &&
        item.top !== null && item.top !== undefined &&
        item.height !== null && item.height !== undefined &&
        Number.isFinite(Number(item.top)) &&
        Number.isFinite(Number(item.height)) &&
        Number(item.height) > 0;
}

export function paperScanCropBottomCm(item) {
    return PAPER_SCAN_QUESTION_ORIGIN_TOP_CM +
        Number(item.top) +
        Number(item.height) +
        PAPER_SCAN_CROP_MARGIN_CM;
}

export function fitsPaperScanGuide(item) {
    return hasPaperScanGeometry(item) &&
        paperScanCropBottomCm(item) < PAPER_SCAN_BOTTOM_GUIDE_TOP_CM;
}

export function isPaperScanQuestionSafe(item) {
    return item &&
        item.page !== null && item.page !== undefined &&
        Number.isInteger(Number(item.page)) &&
        Number(item.page) >= 0 &&
        fitsPaperScanGuide(item);
}
